// 2024-01-01T00:00:00.000ZのDate型を2024年1月1日(月)の文字列に変換
export const useDateTextFormatting = (dateItem: Date | undefined | null) => {
  if (!dateItem) {
    return "";
  }
  const date = new Date(dateItem);
  const DateString = new Intl.DateTimeFormat("ja-JP", {
    day: "numeric",
    month: "long",
    weekday: "short",
    year: "numeric",
  }).format(date);
  return DateString;
};

// 2024-01-01T00:00:00.000ZのDate型を2024年1月の文字列に変換
export const useDateMonthTextFormatting = (
  dateItem: Date | undefined | null,
) => {
  if (!dateItem) {
    return "";
  }
  const date = new Date(dateItem);
  const DateString = new Intl.DateTimeFormat("ja-JP", {
    year: "numeric",
    month: "long",
  }).format(date);
  return DateString;
};

// 2024-01-01T00:00:00.000ZのDate型を2024/01/01の文字列に変換
export const useDateTextFormattingStatus = (
  dateItem: Date | undefined | null,
) => {
  if (!dateItem) {
    return "";
  }
  const date = new Date(dateItem);
  const DateString = new Intl.DateTimeFormat("ja-JP", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(date);
  return DateString;
};

// 2024-01-01T00:00:00.000ZのDate型を日本時間09:00の文字列に変換
export const useTimeTextFormatting = (dateItem: Date | undefined | null) => {
  if (!dateItem) {
    return "";
  }
  const date = new Date(dateItem);
  const TimeString = date.toLocaleTimeString("ja-JP", {
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Asia/Tokyo",
  });
  return TimeString;
};

// 2024-01-01T00:00:00.000ZのDate型を日本時間02022/12/30 00:00の文字列に変換
export const useDateAndTimeTextFormatting = (
  dateItem: Date | undefined | null,
) => {
  if (!dateItem) {
    return "";
  }
  const date = new Date(dateItem);
  const options: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    month: "2-digit",
    year: "numeric",
  };

  const formatter = new Intl.DateTimeFormat("ja-JP", options);
  const formattedDate = formatter.format(date); // "2024/01/01 09:00" (時差補正あり)

  const timeOptions: Intl.DateTimeFormatOptions = {
    hour: "2-digit",
    hour12: false,
    minute: "2-digit",
  };

  const timeFormatter = new Intl.DateTimeFormat("ja-JP", timeOptions);
  const formattedTime = timeFormatter.format(date);

  const result = `${formattedDate
    .replace(/-/g, "-")
    .slice(0, -6)} ${formattedTime}`;

  return result;
};
